// Google Maps
// import { Loader } from "@googlemaps/js-api-loader";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgFullscreen from 'lightgallery/plugins/fullscreen'
import lgVideo from 'lightgallery/plugins/video'

/*** Navbar ***/

(function() {

  // Variables
  // =========

  let $navbar = $('.navbar');
  let $navbarLink = $('.nav-link[href^="#"]'); // anchor link
  let $navbarCollapse = $('.navbar-collapse');
  let $window = $(window);
  let $logoDark = $('.logo-dark');
  let $logoLight = $('.logo-light');

  // Methods
  // =======

  function makeNavbarDark() {
    $navbar.removeClass('navbar-light').addClass('navbar-dark');
    $logoDark.show();
    $logoLight.hide();
  }
  function makeNavbarLight() {
    $navbar.removeClass('navbar-dark').addClass('navbar-light');
    $logoDark.hide();
    $logoLight.show();
  }
  function toggleNavbarClass() {
    let scrollTop = $window.scrollTop();

    if ( scrollTop > 5 ) {
      makeNavbarDark();
    } else {
      makeNavbarLight();
    }
  }

  // Events
  // ======

  // Toggle navbar class on document ready event
  toggleNavbarClass();

  // Window events
  $window.on({
    'scroll': function() {

      // Toggle navbar class on window scroll
      toggleNavbarClass();
    },
    'activate.bs.scrollspy': function() {

      // Navbar active link fix
      $navbarLink.filter('.active').focus();
    }
  });

  // Toggle navbar class on collapse
  $navbarCollapse.on({
    'show.bs.collapse': function() {
      makeNavbarDark();
    },
    'hidden.bs.collapse': function() {
      let scrollTop = $window.scrollTop();

      if (scrollTop == 0) {
        makeNavbarLight();
      }
    }
  });

  // Collapse navbar on an anchor link click
  $navbarLink.on('click', function() {
    $navbarCollapse.collapse('hide');
  });

})();

/*** Gallery ***/

(function() {

  $('.lightgallery').each(function(){
    lightGallery(this, {
      plugins: [lgZoom, lgThumbnail, lgFullscreen, lgVideo],
      licenseKey: '`0000-0000-000-0000',
      selector: '.light_item',
      animateThumb: true,
      fullScreen: true,
      speed: 500,
    });
  })

  // Variables
  // =========

  let $gallery =		$('.section_gallery__grid');
  let galleryItem = 	'.section_gallery__grid__item';

  // Methods
  // =======

  function initGallery() {
    $gallery.each(function() {
      let $this = $(this);
      let grid = $this.isotope({
        itemSelector: galleryItem
      });

      // Init Isotope when all images loaded
      grid.imagesLoaded().progress( function() {
        grid.isotope('layout');
      });
    });
  };

  // Events
  // ======

  if ( $gallery.length ) {
    initGallery();
  }

})();

/*** Google Map ***/

(function() {

  // Variables
  // =========

  let $map = $('.section_map__map');

  // Methods
  // =======

  function init() {

    $map.each(function() {
      let $this = $(this);
      // Get map data
      let mapId = $this.attr('id');
      let mapKey = 	$this.data('key');
      let mapLat = 	$this.data('lat');
      let mapLng = 	$this.data('lng');
      let mapZoom = 	$this.data('zoom');
      let mapInfo = 	$this.data('info');
      // Get map styles
      let mapStyles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
      // Set the options for loading the API.
      setOptions({ key: $(this).data('key') });
      importLibrary("marker"); // needed for <gmp-advanced-marker>

      // Load library
      importLibrary("maps").then(({ Map }) => {
        // Create a map object
        let map = new Map( $this[0], {
          mapId: mapId,
          center: {
            lat: mapLat,
            lng: mapLng
          },
          zoom: mapZoom,
          //styles: mapStyles,
          mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map']
          },
          disableDefaultUI: false,
          scrollwheel: false
        });
        // Create a marker
        customElements.whenDefined("gmp-map").then(() => {
          let map = document.querySelector("gmp-map");
        });
        let marker = new google.maps.marker.AdvancedMarkerElement({
          position: {
            lat: mapLat,
            lng: mapLng
          },
          map: map
        });

        // Create an info window
        let infoWindow = new google.maps.InfoWindow({
          content: mapInfo,
          maxWidth: 300
        });
        infoWindow.open(map, marker);

        // Make marker visible on info window close event
        google.maps.event.addListener(marker, 'click', function() {
          marker.setVisible(true);
          infoWindow.open(map, marker);
        });
        // Make marker visible on info window close event
        google.maps.event.addListener(infoWindow, 'closeclick', function() {
          marker.setVisible(true);
        });
      });

    });

  }

  // Events
  // ======

  if ( $map.length ) {
    init();
  }

})();


/*** Current Date ***/

(function() {

  // Variables
  // =========

  let $dateContainer = $('#js-current-year');

  // Methods
  // =======

  function appendDate() {
    let currentYear = new Date().getFullYear();

    $dateContainer.text(currentYear);
  }

  // Events
  // ======

  if ( $dateContainer.length ) {
    appendDate();
  }

})();
